<template>
  <t-card>
    <t-form
      ref="loginForm"
      name="loginForm"
      domain="loginForm"
      :model="passwordForm"
      label-position="left"
    >
      <div class="label-text">
        {{ $t("resource.txt.inputPwd") }}
      </div>
      <t-tooltip
        v-model="capsTooltip"
        content="Caps lock is On"
        placement="right"
        manual
      >
        <t-form-item prop="oldPassword">
          <t-input
            key="oldPassword"
            ref="oldPassword"
            v-model="passwordForm.oldPassword"
            name="oldPassword"
            type="password"
            placeholder=""
            tabindex="1"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
          />
        </t-form-item>
      </t-tooltip>

      <div class="label-text">
        {{ $t("resource.txt.inputNewPwd") }}
      </div>
      <t-tooltip
        v-model="capsTooltip"
        content="Caps lock is On"
        placement="right"
        manual
      >
        <t-form-item prop="newPassword">
          <t-input
            key="newPassword"
            ref="newPassword"
            v-model="passwordForm.newPassword"
            type="password"
            placeholder=""
            name="newPassword"
            tabindex="2"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
          />
        </t-form-item>
      </t-tooltip>

      <div class="label-text">
        {{ $t("resource.txt.confirmPwd") }}
      </div>
      <t-tooltip
        v-model="capsTooltip"
        content="Caps lock is On"
        placement="right"
        manual
      >
        <t-form-item prop="checkPassword">
          <t-input
            key="checkPassword"
            ref="checkPassword"
            v-model="passwordForm.checkPassword"
            type="password"
            placeholder=""
            name="checkPassword"
            tabindex="3"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
          />
        </t-form-item>
      </t-tooltip>
      <t-form-item class="float-right pr-0 tableButton">
        <t-button
          round
          type="warning"
          class="dialogButton_confirm_120_40"
          @click.native.prevent="changePwd()"
        >
          <i class="el-icon-check"></i
          >{{ $t("resource.button.change") }}</t-button
        >
      </t-form-item>
    </t-form>
  </t-card>
</template>

<script>
import { t } from "@/locales";
import service from "@/services/system";
import { Message } from "@tellus/component";
//import { encryptByMd5 } from '@/utils/crypto'

export default {
  name: "ChangePwdDialog",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        checkPassword: "",
      },
      capsTooltip: false,
      userId: "",
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.userId = this.id;
    },
    checkCapslock(e) {
      const { key } = e;
      this.capsTooltip = key && key.length === 1 && key >= "A" && key <= "Z";
    },
    changePwd() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          if (
            this.passwordForm.newPassword == this.passwordForm.checkPassword
          ) {
            service
              .ChangePwd({
                userId: this.userId,
                oldPassword: this.passwordForm.oldPassword,
                newPassword: this.passwordForm.newPassword,
              })
              .then((res) => {
                Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
                this.$emit("ok");
              })
              .catch((err) => {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              });
          } else {
            Message.showError(t("message.loginForm.changePwd1"));
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title-container {
  position: relative;

  .title {
    margin: 0 auto 10px;
    color: #000;
    font-size: 26px;
    font-weight: bold;
    text-align: center;
  }
}

.changePwdDialog {
  .el-form-item {
    margin-bottom: 34px;
  }
}
</style>
@/services/system
